// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1WoVE","noInteraction":"EventWrapper_noInteraction__1cuq0"};